import ArticleRoundedIcon from "@mui/icons-material/ArticleRounded";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import SwipeVerticalIcon from "@mui/icons-material/SwipeVertical";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { Avatar, Tooltip } from "@mui/material";

export const tableLayout = {
  en: [
    {
      width: 60,
      label: "Source",
      dataKey: "source",
      type: "map",
      hashmap: {
        manual: (
          <Tooltip title="Manual" placement="top">
            <Avatar style={{ backgroundColor: "#46A0E1", width: 28, height: 28 }}>
              <ArticleRoundedIcon fontSize="small" />
            </Avatar>
          </Tooltip>
        ),
        "content-creator": (
          <Tooltip title="Content Creator" placement="top">
            <Avatar style={{ backgroundColor: "#E16846", width: 28, height: 28 }}>
              <AutoAwesomeIcon fontSize="small" />
            </Avatar>
          </Tooltip>
        ),
        video2article: (
          <Tooltip title="Video" placement="top">
            <Avatar style={{ backgroundColor: "#46E19B", width: 28, height: 28 }}>
              <OndemandVideoIcon fontSize="small" />
            </Avatar>
          </Tooltip>
        ),
        reframer: (
          <Tooltip title="Reframer" placement="top">
            <Avatar style={{ backgroundColor: "#9B46E1", width: 28, height: 28 }}>
              <SwipeVerticalIcon fontSize="small" />
            </Avatar>
          </Tooltip>
        ),
        "url-rewriter": (
          <Tooltip title="RankLens" placement="top">
            <Avatar style={{ backgroundColor: "#2e7d32", width: 28, height: 28 }}>
              <AutoFixHighIcon fontSize="small" />
            </Avatar>
          </Tooltip>
        ),
      },
    },
    {
      width: 360,
      label: "Title",
      dataKey: "title",
      type: "redirection",
      href: "/editor",
      reframerHref: "/player",
    },
    {
      width: 200,
      label: "Tags",
      dataKey: "tags",
      type: "tags",
    },

    {
      width: 90,
      label: "Created",
      dataKey: "created",
      type: "date",
    },
    {
      width: 90,
      label: "Published",
      dataKey: "published",
      type: "checkbox",
    },
    {
      width: 140,
      label: "Quick Actions",
      dataKey: "actions",
      type: "actions",
    },
  ],
  heb: [
    {
      width: 60,
      label: "מקור",
      dataKey: "source",
      type: "map",
      hashmap: {
        manual: (
          <Tooltip title="ידני" placement="top">
            <Avatar style={{ backgroundColor: "#46A0E1", width: 28, height: 28 }}>
              <ArticleRoundedIcon fontSize="small" />
            </Avatar>
          </Tooltip>
        ),
        "content-creator": (
          <Tooltip title="יוצר תוכן" placement="top">
            <Avatar style={{ backgroundColor: "#E16846", width: 28, height: 28 }}>
              <AutoAwesomeIcon fontSize="small" />
            </Avatar>
          </Tooltip>
        ),
        video2article: (
          <Tooltip title="וידאו" placement="top">
            <Avatar style={{ backgroundColor: "#46E19B", width: 28, height: 28 }}>
              <OndemandVideoIcon fontSize="small" />
            </Avatar>
          </Tooltip>
        ),
        reframer: (
          <Tooltip title="המרה וורטיקלית" placement="top">
            <Avatar style={{ backgroundColor: "#9B46E1", width: 28, height: 28 }}>
              <SwipeVerticalIcon fontSize="small" />
            </Avatar>
          </Tooltip>
        ),
        "url-rewriter": (
          <Tooltip title="RankLens" placement="top">
            <Avatar style={{ backgroundColor: "#2e7d32", width: 28, height: 28 }}>
              <AutoFixHighIcon fontSize="small" />
            </Avatar>
          </Tooltip>
        ),
      },
    },
    {
      width: 360,
      label: "כותרת",
      dataKey: "title",
      type: "redirection",
      href: "/editor",
      reframerHref: "/player",
    },
    {
      width: 200,
      label: "תגיות",
      dataKey: "tags",
      type: "tags",
    },

    {
      width: 90,
      label: "נוצר ב",
      dataKey: "created",
      type: "date",
    },
    {
      width: 90,
      label: "פורסם",
      dataKey: "published",
      type: "checkbox",
    },
    {
      width: 140,
      label: "פעולות מהירות",
      dataKey: "actions",
      type: "actions",
    },
  ],
};
